module.exports = __webpack_public_path__ + "img/10073_logo-QualiPV-2022-RGE.89a2acb8.jpg";